<template>
  <div>
    <div class="d-flex justify-content-between align-items-center">
      <h4 class="mb-0 ml-2" style="font-size: 16px">Guarantors</h4>
      <a
        href="#"
        v-if="hasCurrentUserPermissionAccess('patients', 'create')"
        style="font-size: 14px"
        @click.prevent="$emit('onEdit', 5)"
      >
        Edit
      </a>
    </div>
    <div
      v-for="guarantor in guarantors"
      :key="guarantor.id"
      class="d-flex flex-column border-top p-2 mt-2"
      style="font-size: 14px;"
    >
      <div class="mb-2">
        <strong>{{ guarantor.name }}</strong>
      </div>
      <div v-if="guarantor.email" class="mb-2">
        <i class="fa fa-envelope mr-2" aria-hidden="true"></i>
        <span>{{ guarantor.email }}</span>
      </div>
      <div v-if="guarantor.phone" class="mb-2">
        <i class="fa fa-phone mr-2" aria-hidden="true"></i>
        <span>{{ guarantor.phone }}</span>
      </div>
      <div v-if="guarantor.address" class="mb-2">
        <i class="fa fa-home mr-2" aria-hidden="true"></i>
        <span>{{ guarantor.address }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "EocViewSummaryGuarantors",
  props: ["eoc"],
  computed: {
    ...mapGetters("layout", ["hasCurrentUserPermissionAccess"]),
    guarantors() {
      if (this.eoc.patient.guarantors) {
        return this.eoc.patient.guarantors.map(g => {
          const addressItems = [
            ...(g.address ? [g.address] : []),
            ...(g.city ? [g.city] : []),
            ...(g.state ? [g.state.name] : []),
            ...(g.zipCode ? [g.zipCode] : [])
          ];

          return {
            name: `${g.firstName + " " + g.middleName + " " + g.lastName}${
              g.relationship ? " (" + g.relationship.name + ")" : ""
            }`,
            email: g.email,
            phone: g.phone,
            address: addressItems.join(", ")
          };
        });
      }

      return [];
    }
  }
};
</script>
